// extracted by mini-css-extract-plugin
module.exports = {"circle":"setNewPasswordSuccess_circle__3kafw","anim":"setNewPasswordSuccess_anim__1rXip"};